// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__n7ygh","logo":"Navbar_logo__jA5Pb","navLinks":"Navbar_navLinks__UMGgk","buttonWithMargin":"Navbar_buttonWithMargin__7myf-"};